import ApiService from "@/services/api.service";

const route = 'import-old-version';

const imports = {
    connect(_dataOfConnection) {
        return new Promise((resolve, reject) => {
            ApiService.post(route + "-connect", _dataOfConnection).then(({ data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    },

    do(_data) {
        return new Promise((resolve, reject) => {
            ApiService.post(route, _data).then(({data}) => {
                resolve(data);
            }, (error) => {
                reject(error);
            });
        });
    }
};

export default imports;